export const contactSeniorityLevels: { value: string; label: string }[] = [
  { value: 'cxo', label: 'CXO (Executive)' },
  { value: 'owner', label: 'Owner' },
  { value: 'partner', label: 'Partner' },
  { value: 'vp', label: 'VP' },
  { value: 'director', label: 'Director' },
  { value: 'manager', label: 'Manager' },
  { value: 'senior', label: 'Senior' },
  { value: 'entry', label: 'Entry level' },
  { value: 'training', label: 'Trainee' },
  { value: 'unpaid', label: 'Intern' },
];

export const contactIndustries: string[] = [
  'Accounting',
  'Airlines/Aviation',
  'Alternative Dispute Resolution',
  'Alternative Medicine',
  'Animation',
  'Apparel & Fashion',
  'Architecture & Planning',
  'Arts And Crafts',
  'Automotive',
  'Aviation & Aerospace',
  'Banking',
  'Biotechnology',
  'Broadcast Media',
  'Building Materials',
  'Business Supplies And Equipment',
  'Capital Markets',
  'Chemicals',
  'Civic & Social Organization',
  'Civil Engineering',
  'Commercial Real Estate',
  'Computer & Network Security',
  'Computer Games',
  'Computer Hardware',
  'Computer Networking',
  'Computer Software',
  'Construction',
  'Consumer Electronics',
  'Consumer Goods',
  'Consumer Services',
  'Cosmetics',
  'Dairy',
  'Defense & Space',
  'Design',
  'E Learning',
  'Education Management',
  'Electrical/Electronic Manufacturing',
  'Entertainment',
  'Environmental Services',
  'Events Services',
  'Executive Office',
  'Facilities Services',
  'Farming',
  'Financial Services',
  'Fine Art',
  'Fishery',
  'Food & Beverages',
  'Food Production',
  'Fund Raising',
  'Furniture',
  'Gambling & Casinos',
  'Glass, Ceramics & Concrete',
  'Government Administration',
  'Government Relations',
  'Graphic Design',
  'Health, Wellness And Fitness',
  'Higher Education',
  'Hospital & Health Care',
  'Hospitality',
  'Human Resources',
  'Import And Export',
  'Individual & Family Services',
  'Industrial Automation',
  'Information Services',
  'Information Technology And Services',
  'Insurance',
  'International Affairs',
  'International Trade And Development',
  'Internet',
  'Investment Banking',
  'Investment Management',
  'Law Practice',
  'Legal Services',
  'Legislative Office',
  'Leisure, Travel & Tourism',
  'Libraries',
  'Logistics And Supply Chain',
  'Luxury Goods & Jewelry',
  'Machinery',
  'Management Consulting',
  'Maritime',
  'Market Research',
  'Marketing And Advertising',
  'Mechanical Or Industrial Engineering',
  'Media Production',
  'Medical Devices',
  'Medical Practice',
  'Mental Health Care',
  'Military',
  'Mining & Metals',
  'Motion Pictures And Film',
  'Museums And Institutions',
  'Music',
  'Nanotechnology',
  'Newspapers',
  'Non Profit Organization Management',
  'Oil & Energy',
  'Online Media',
  'Outsourcing/Offshoring',
  'Package/Freight Delivery',
  'Packaging And Containers',
  'Paper & Forest Products',
  'Performing Arts',
  'Pharmaceuticals',
  'Philanthropy',
  'Photography',
  'Plastics',
  'Political Organization',
  'Primary/Secondary Education',
  'Printing',
  'Professional Training & Coaching',
  'Program Development',
  'Public Policy',
  'Public Relations And Communications',
  'Public Safety',
  'Publishing',
  'Railroad Manufacture',
  'Real Estate',
  'Recreational Facilities And Services',
  'Religious Institutions',
  'Renewables & Environment',
  'Research',
  'Restaurants',
  'Retail',
  'Security And Investigations',
  'Semiconductors',
  'Shipbuilding',
  'Sporting Goods',
  'Sports',
  'Staffing And Recruiting',
  'Supermarkets',
  'Telecommunications',
  'Textiles',
  'Think Tanks',
  'Tobacco',
  'Translation And Localization',
  'Transportation/Trucking/Railroad',
  'Utilities',
  'Venture Capital & Private Equity',
  'Veterinary',
  'Warehousing',
  'Wholesale',
  'Wine And Spirits',
  'Wireless',
  'Writing And Editing',
];

export const contactEmployeeCountRanges: { value: number; label: string }[] = [
  { value: 1, label: '1' },
  { value: 2, label: '10' },
  { value: 3, label: '50' },
  { value: 4, label: '200' },
  { value: 5, label: '500' },
  { value: 6, label: '1000' },
  { value: 7, label: '5000' },
  { value: 8, label: '10000' },
  { value: 9, label: '10000+' },
];

export const monthOptions = [
  { value: '01', display: '01- January' },
  { value: '02', display: '02- February' },
  { value: '03', display: '03- March' },
  { value: '04', display: '04- April' },
  { value: '05', display: '05- May' },
  { value: '06', display: '06- June' },
  { value: '07', display: '07- July' },
  { value: '08', display: '08- August' },
  { value: '09', display: '09- September' },
  { value: '10', display: '10- October' },
  { value: '11', display: '11- November' },
  { value: '12', display: '12- December' },
];

export const CHATBOT_INTERACTION_TYPES = {
  OPEN: 'open',
  CLOSE: 'close',
} as const;

export const COURT_CASES = 'COURT_CASES' as const;
